export const uk = {
    'no-phrases-for-replace': 'Фразы для замены не найдены'
};
